import React, { memo } from 'react';
import { TrendingUpIcon, ShieldIcon, GlobeIcon, SearchIcon, BarChartIcon, UsersIcon } from 'lucide-react';
export const BenefitsSection = () => {
  const benefits = [{
    title: 'Brand Control',
    description: 'Own your digital namespace and control how your brand appears online.',
    icon: <ShieldIcon className="h-8 w-8 text-[#C4A44A]" data-id="element-15" />
  }, {
    title: 'Market Differentiation',
    description: 'Stand out from competitors with a unique domain extension.',
    icon: <TrendingUpIcon className="h-8 w-8 text-[#C4A44A]" data-id="element-16" />
  }, {
    title: 'Global Recognition',
    description: 'Enhance your global digital presence with a memorable domain.',
    icon: <GlobeIcon className="h-8 w-8 text-[#C4A44A]" data-id="element-17" />
  }, {
    title: 'Enhanced Security',
    description: 'Implement stricter security protocols on your own TLD.',
    icon: <ShieldIcon className="h-8 w-8 text-[#C4A44A]" data-id="element-18" />
  }, {
    title: 'SEO Opportunities',
    description: 'Create keyword-rich domains that can improve search visibility.',
    icon: <SearchIcon className="h-8 w-8 text-[#C4A44A]" data-id="element-19" />
  }, {
    title: 'New Revenue Streams',
    description: 'Generate revenue by selling second-level domains within your TLD.',
    icon: <BarChartIcon className="h-8 w-8 text-[#C4A44A]" data-id="element-20" />
  }];
  return <section id="benefits" className="py-20 bg-[#FAF9F5]" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-24">
            Benefits of New gTLDs
          </h2>
          <div className="w-24 h-1 bg-[#C4A44A] mx-auto mb-6" data-id="element-25"></div>
          <p className="text-xl text-[#5A5535] max-w-3xl mx-auto font-light" data-id="element-26">
            Owning a gTLD provides numerous strategic advantages for
            organizations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-27">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-10 rounded-sm border border-[#EDE9DB] shadow-sm hover:shadow-md hover:border-[#C4A44A] transition-all duration-300 group" data-id="element-28">
              <div className="bg-[#FAF9F5] p-4 rounded-full inline-block mb-6 group-hover:bg-[#EDE9DB] transition-colors" data-id="element-29">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-[#1E1D14] mb-3 font-serif" data-id="element-30">
                {benefit.title}
              </h3>
              <p className="text-[#3D3A25] leading-relaxed" data-id="element-31">
                {benefit.description}
              </p>
            </div>)}
        </div>

        <div className="mt-20 bg-[#5A5535] rounded-sm overflow-hidden shadow-xl" data-id="element-32">
          <div className="md:flex" data-id="element-33">
            <div className="md:w-2/3 p-10 md:p-16" data-id="element-34">
              <h3 className="text-2xl md:text-4xl font-bold text-white mb-6 font-serif" data-id="element-35">
                Ready to transform your digital presence?
              </h3>
              <p className="text-[#EDE9DB] mb-10 text-lg font-light max-w-xl" data-id="element-36">
                Join the ranks of forward-thinking organizations that have
                secured their place in the future of the internet.
              </p>
              <a href="#contact" className="inline-flex items-center px-8 py-4 border border-transparent text-sm font-bold uppercase tracking-wider rounded-sm text-[#1E1D14] bg-[#C4A44A] hover:bg-white transition-colors" data-id="element-37">
                Start Your gTLD Journey
              </a>
            </div>
            <div className="md:w-1/3 bg-[#3D3A25] flex items-center justify-center p-10 relative overflow-hidden" data-id="element-38">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070')] opacity-10 bg-cover bg-center" data-id="element-39"></div>
              <div className="text-center relative z-10" data-id="element-40">
                <div className="flex justify-center" data-id="element-41">
                  <UsersIcon className="h-16 w-16 text-[#C4A44A]" data-id="element-42" />
                </div>
                <p className="mt-6 text-4xl font-bold text-white font-serif" data-id="element-43">
                  1,930+
                </p>
                <p className="text-white uppercase tracking-wide text-sm mt-2" data-id="element-44">
                  New gTLDs registered
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};